import { Pipe, PipeTransform } from '@angular/core';
import {CellTransformerFn} from "../generic-table.component";

@Pipe({
  name: 'cellTransformer',
  standalone: true,
})
export class CellTransformerPipe implements PipeTransform {

  transform(
    value: any,
    row: any,
    index: number,
    transformer: CellTransformerFn
  ) {
    return transformer({ value, rowData: row, index });
  }

}
